// Field definitions for the Financial Compliance section (Estimating + Turnover).
// The DB (EstimateFinancialCompliance / TurnoverFinancialCompliance, db/27)
// stores only values, so adding, removing, or re-labeling a field here is a
// frontend-only change — no migration needed.
//
// `key` matches the PascalCase column name returned by sp_GetFinancialCompliance
// / sp_GetTurnoverDetail's FinancialComplianceJson. `param` is the snake_case
// name the save procs (sp_SaveFinancialCompliance / sp_SaveTurnoverFinancialCompliance)
// read via JSON_VALUE.

export const TAX_STATUS_OPTIONS = ["Taxable", "Exempt", "Partial", "Direct Pay", "Resale"];

export const DOC_STATUS_OPTIONS = ["Not Required", "Requested", "Received", "Verified", "Expired", "Missing"];

// Bid-time assumptions — captured per estimate revision (EstimateFinancialCompliance),
// then ported once into the turnover-side record at turnover creation.
export const FINANCIAL_COMPLIANCE_FIELDS = [
  { key: "TaxStatus", param: "tax_status", label: "Tax Status", type: "select", options: TAX_STATUS_OPTIONS },
  { key: "TaxJurisdiction", param: "tax_jurisdiction", label: "Tax Jurisdiction", type: "text",
    placeholder: "e.g. state / county / city" },
  { key: "TaxRateSource", param: "tax_rate_source", label: "Tax Rate Source", type: "text",
    placeholder: "e.g. QBO, Avalara, manual lookup" },
  { key: "ExemptionType", param: "exemption_type", label: "Exemption Type", type: "text",
    placeholder: "e.g. government, manufacturing, resale" },
  { key: "RetainagePct", param: "retainage_pct", label: "Retainage %", type: "number" },
  { key: "BondsStatus", param: "bonds_status", label: "Bonds", type: "select", options: DOC_STATUS_OPTIONS },
  { key: "LienWaiversStatus", param: "lien_waivers_status", label: "Lien Waivers", type: "select", options: DOC_STATUS_OPTIONS },
  { key: "CertifiedPayrollRequired", param: "certified_payroll_required", label: "Certified Payroll Required", type: "boolean" },
  { key: "PrevailingWage", param: "prevailing_wage", label: "Prevailing Wage", type: "boolean",
    hint: "If yes, the Administrative Documents section at turnover requires an uploaded Prevailing Wage Determination before it can be marked complete." },
  { key: "SalesTaxNotes", param: "sales_tax_notes", label: "Sales Tax Notes", type: "textarea" },
];

// Turnover-only fields — paperwork that doesn't exist until after award.
export const TURNOVER_ONLY_FIELDS = [
  { key: "ExemptionCertNumber", param: "exemption_cert_number", label: "Exemption Certificate Number", type: "text" },
  { key: "CertificateExpiration", param: "certificate_expiration", label: "Certificate Expiration", type: "date" },
  { key: "W9Status", param: "w9_status", label: "W-9", type: "select", options: DOC_STATUS_OPTIONS },
  { key: "COIStatus", param: "coi_status", label: "Certificate of Insurance (COI)", type: "select", options: DOC_STATUS_OPTIONS },
];
